import React from "react";
import { isInShell } from "../../common/Shell";
import { useContainer } from "../../routes/home/Home";
import './ContactKaiaFormText.css';

/**
 * A component that displays a text prompt to contact Kaia for storage upgrade.
 * Only renders when the application is running within the shell environment.
 * 
 * @component
 * @returns {JSX.Element} A text element with "1 GB free" information and a clickable "Contact us to upgrade" link,
 * or an empty fragment if not in shell.
 * 
 * @example
 * ```tsx
 * <ContactKaiaFormText />
 * ```
 */
const ContactKaiaFormText = () => {
  const inShell = React.useMemo(() => isInShell(), [])
  const { openKaiaContactForm } = useContainer();

  if (!inShell)
    return <></>

  return (
    <div className="kt-ui-app kt-flowbite">
      <p className="in-shell-kaia-contact-text">
        <span className="in-shell-kaia-contact-text-info bold">1 GB free</span>{' '}<span className="in-shell-kaia-contact-text-action" onClick={openKaiaContactForm}>Contact us to upgrade</span>
      </p>
    </div>
  );
}

export default ContactKaiaFormText;